/* ============================================================
 * File: main.js
 * Main Controller to set global scope variables.
 * ============================================================ */
import * as Sentry from "@sentry/browser";
import currencies from './transaction/currencies'
import socket from "../libs/socket";
import { getAccessToken } from "../libs/auth";
import api from '../libs/api';

angular.module("AccountingBoxApp").controller("AppCtrl", [
  "$scope",
  "$rootScope",
  "$state",
  "Auth",
  "LoopBackAuth",
  "Company",
  function($scope, $rootScope, $state, Auth, LoopBackAuth, $timeout) {

    // App globals
    $scope.app = {
      name: "AccountingBox",
      description: "Innovating Accounting for Entrepreneurs",
      layout: {
        menuPin: false,
        menuBehind: false,
        theme: "pages/css/themes/AccountingBox.css"
      },
      author: "AdministratieBox B.V."
    };

    var propsPrefix = "AB-";

    $rootScope.window = window;
    $rootScope.alert = alert;

    $rootScope.toggleNotes = function() {
      window.toggleNotes()
    }

    $rootScope.getBookkeepers = async function() {
      const data=  await api.get('/users/bookkeepers')
      return data;
    }

    $rootScope.readonly = function() {
      if ($rootScope.isBookkeeper()) {
        return "readonly";
      } else {
        return "false";
      }
    };

    $rootScope.companyUrl = function(url) {
      return "/" + $rootScope.currentCompany.slug + "/" + url;
    };

    $rootScope.logout = function() {
      if (window.Intercom !== undefined) {
        window.Intercom("shutdown");
      }
      analytics.reset();
      Sentry.setUser();
      Auth.logout();
      localStorage.clear();
      $rootScope.currentCompany = null;
      $state.go("login");
    };

    $rootScope.editSettings = function(company, registration) {
      console.log("company:", company);
      console.log("current company:", $rootScope.currentCompany);

      $rootScope.$broadcast("editCompany", company);
      if (registration) {
        $("#companySettingsModal").modal(
          {
            backdrop: "static",
            keyboard: false
          },
          "show"
        );
        setTimeout(function() {
          $("span.ui-select-toggle").click();
        }, 700);
      } else {
        $("#companySettingsModal").modal("show");
      }
    };

    $rootScope.currentYear = function() {
      var beginDate =
        $rootScope.currentCompany.openingBalanceDate ||
        $rootScope.currentCompany.startDate;
      return (moment(beginDate).get("year") || moment().get("year")).toString();
    };

    $rootScope.formattedWebsite = function(website) {
      if (!website) {
        website = "";
      }
      return website.replace(/^https?:\/\//, "");
    };

    $rootScope.eventNames = {
      'purchase.created': 'Inkoopfactuur aangemaakt',
      'purchase.updated': 'Inkoopfactuur bijgewerkt',
      'sale.created': 'Verkoopfactuur aangemaakt',
      'sale.updated': 'Verkoopfactuur bijgewerkt',
      'journal_entry.created': 'Memoriaal aangemaakt',
      'journal_entry.updated': 'Memoriaal bijgewerkt',
      'bank_transaction.created': 'Banktransactie aangemaakt',
      'bank_transaction.updated': 'Banktransactie bijgewerkt',
    }

    $rootScope.attachmentSourceIcon = {
      'webapp': 'fa-laptop',
      'email': 'fa-envelope-o',
      'mobile': 'fa-mobile',
      'system': 'fa-robot'
    }

    $rootScope.attachmentSourceTitle = {
      'webapp': 'via webapp',
      'email': 'via e-mail',
      'mobile': 'via mobiele app',
      'system': 'systeem gegenereerd'
    }


    $rootScope.defaultDisplayYear = "open";
    $rootScope.getCurrentUser = Auth.getCurrentUser;


    $rootScope.displayYears = [
      { label: "Elk jaar", value: "all" },
      { label: "Open boekjaar", value: "open" },
      { label: "2024", value: 2024 },
      { label: "2023", value: 2023 },
      { label: "2022", value: 2022 },
      { label: "2021", value: 2021 },
      { label: "2020", value: 2020 },
      { label: "2019", value: 2019 },
      { label: "2018", value: 2018 },
      { label: "2017", value: 2017 },
      { label: "2016", value: 2016 },
      { label: "2015", value: 2015 }
    ];

    $rootScope.displayDateFilter = function(year) {
      if (year === "all") {
        return null;
      } else if (year === "open") {
        return {
          gte: moment()
            .year($rootScope.currentYear())
            .startOf("year")
            .toDate()
        };
      } else {
        return {
          gte:
            moment()
              .year(year)
              .startOf("year")
              .toDate(),
            lte: moment()
              .year(year)
              .endOf("year")
              .toDate()
        };
      }
    };

    $rootScope.currencies = currencies;

    function load(name) {
      var key = propsPrefix + name;
      return JSON.parse(localStorage[key] || null);
    }

    function isBookkeeper() {
      if (
        LoopBackAuth.currentUserData &&
        LoopBackAuth.currentUserData.isBookkeeper
      ) {
        return true;
      } else {
        return false;
      }
    }
    $rootScope.isBookkeeper = function() {
      return isBookkeeper();
    };

    function isExternalBookkeeper() {
      if (
        LoopBackAuth.currentUserData &&
        LoopBackAuth.currentUserData.isExternalBookkeeper
      ) {
        return true;
      } else {
        return false;
      }
    }

    $rootScope.isExternalBookkeeper = function() {
      return isExternalBookkeeper();
    };

    $rootScope.isDemo = function() {
      if ($rootScope.currentCompany && $rootScope.currentCompany.demo) {
        return true;
      }
      return false;
    };
    $rootScope.isAdmin = function() {
      // console.log('isadmin',LoopBackAuth.currentUserData);
      if (
        LoopBackAuth.currentUserData &&
        LoopBackAuth.currentUserData.isAdmin
      ) {
        return true;
      }
      return false;
    };

    $rootScope.logoUrl = function(website, size) {
      var url;
      if (website) {
        url = "https://logo.clearbit.com/" + website.replace(/.*?:\/\//g, "");
      }
      if (size) {
        url += "?size=" + size;
      }
      if (url) {
        $rootScope.hideLogo = false;
        return url;
      } else {
        $rootScope.hideLogo = true;
        return false;
      }
    };

    $rootScope.goToState = function(state) {
      $state.go(state);
    };

    $rootScope.export = function(printAreaId) {
      var pageName = $state.current.url.replace("/", "");

      printAreaId = printAreaId || "section-to-print";
      XLSX.SSF.format('#,##0.00', 5)
      var wb = XLSX.utils.table_to_book(document.getElementById(printAreaId),{raw: true});
      for (const [key, value] of Object.entries(wb.Sheets.Sheet1)) {
        if (!value.v) continue;
        if(!value.v.match(/[0-9]+,[0-9]{2}$/)) continue;
        var number = value.v.replace('.','').replace(/€ ?/g,'').replace(',','.')
        if(!isNaN(number)) {
          wb.Sheets.Sheet1[key].t = 'n';
          wb.Sheets.Sheet1[key].v = Number(number);
          wb.Sheets.Sheet1[key].z = ' #,##0.00';

        }
      }
      console.log('wb',wb)
      var name =
        $rootScope.currentCompany.name +
        "-" +
        moment().format("YYYYMMDD") +
        "-" +
        pageName +
        "-export.xlsx";

      XLSX.writeFile(wb, name);
    };

    $rootScope.print = function(printAreaId) {
      printAreaId = printAreaId || "section-to-print";
      var height = $("#section-to-print").height();
      console.log("height table is:", height);
      // $('#page-container').css('height',height+'px');
      console.log("Functionality to run before printing.");

      var divName = printAreaId;
      var printContents = document.getElementById(divName).outerHTML;
      // var popupWin = window.open('', '_blank', 'width=1,height=1');
      var h = window.screen.height;
      var w = window.screen.width * 0.5;
      var left = window.screen.width / 2 - w / 2;
      var top = window.screen.height / 2 - h / 2;
      top = 0;
      var popupWin = window.open(
        "",
        "Printen",
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left
      );

      popupWin.document.open();
      var head = $("head").html();
      console.log("head is:", head);
      popupWin.document.write(
        "<html>" + head + "<body><style> body { zoom: 65%;} </style>" + printContents + "</body></html>"
      );
      //    popupWin.document.close();
      setTimeout(function() {
        if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
          var showPopup = false;
          popupWin.onbeforeunload = function() {
            if (showPopup) {
              return "You must use the Cancel button to close the Print Preview window.\n";
            } else {
              showPopup = true;
            }
          };
          popupWin.print();
          //  popupWin.close();
        } else {
          popupWin.print();
          //  popupWin.close();
        }
      }, 800);
    };

    $rootScope.navigate = function($event, to, params) {

      // If the command key is down, open the URL in a new tab
      if ($event.metaKey) {
        let url = $state.href(to, params, {absolute: true});
        window.open(url,'_blank');
      } else {
        $state.go(to, params);
      }

    };

    $rootScope.download = function(data, fileName) {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(data);
            link.download = fileName;
            link.click();
    };

    $rootScope.getAttachmentPreview = function(attachmentId, format, height=300) {
      // const url = $rootScope.getAttachmentUrl(attachmentId, format === 'annotated' ? format : 'original').replace(API_ENDPOINT,'https://api.accountingbox.nl')
      const url = $rootScope.getAttachmentUrl(attachmentId, format).replace(API_ENDPOINT,'https://api.accountingbox.nl')
      return url;
      return (
        `https://images.accountingbox.nl/thumbnail?type=png&height=${height}&url=${url}`
      );

    };

    $rootScope.getAttachmentUrl = function(attachmentId, format) {
      var url =
        API_ENDPOINT +
        "/Attachments/" +
        attachmentId +
        "/download?format=" +
        format +
        "&access_token=" +
        LoopBackAuth.accessTokenId;

      if ($rootScope.currentCompany) {
        url = url + "&currentCompanyId=" + $rootScope.currentCompany.id;
      }

      return url;
    };

    $scope.offset = function() {
      if (isBookkeeper()) {
        return 0;
      } else if ($rootScope.isDemo()) {
        return 35;
      } else {
        return 0;
      }
    };

    $scope.innerContainerOffset = function() {
      return $scope.offset() + 50;
    };

    // Checks if the given state is the current state
    $scope.is = function(name) {
      return $state.is(name);
    };

    // Checks if the given state/child states are present
    $rootScope.includes = function(name) {

      return $state.includes(name);
    };

    $rootScope.isReactPage = function() {

      const reactStates = [
        'app.company.bank.transactions2'
      ]

      const output = reactStates.some((state) => $state.includes(state))

      return output
    };

    $rootScope.dueDateExpired = function(dueDate) {
      var today = new Date();
      var dd = new Date(dueDate);
      if (dd.getTime() < today.getTime()) {
        return true;
      } else {
        return false;
      }
      // body...
    };

    // Calculateds the tax rate percentage based on the date
    $rootScope.getVatCodePercentage = function(vatCode, date) {
      var rate = _.sortBy(
        vatCode.rates.filter(function(rate) {
          return date.isSameOrAfter(rate.beginDate);
        }),
        "beginDate"
      ).reverse()[0];

      if (!rate) {
        return 0;
      }
      return rate.percentage;
    };

    $rootScope.startsWith = function(word, viewValue) {
      if (typeof word != "string") {
        word = word.toString();
      }
      return (
        word.substr(0, viewValue.length).toLowerCase() ==
        viewValue.toLowerCase()
      );
    };
    $rootScope.extractWords = function(text) {
      return _.uniq(text.replace(/\n/g, " ").split(" "));
    };

    $rootScope.invoiceNumberSuggestions = function(text) {
      var suggestions = $rootScope.extractWords(text) || [];
      //only return words with at least 4 numbers in it
      suggestions = suggestions.filter(function(suggestion) {
        return suggestion.match(/[0-9].*[0-9].*[0-9].*[0-9]/g);
      });

      //remove dots
      suggestions = suggestions.map(function(suggestion) {
        return suggestion.replace(/\./g, "");
      });
      suggestions = _.uniq(suggestions);
      return suggestions;
    };

    $rootScope.extractNumbers = function(text) {
      var extractedNumbers = $rootScope
        .extractWords(text)
        .filter(function(word) {
          //check if starts with a number
          return !isNaN(parseInt(word[0]));
        });
      extractedNumbers = extractedNumbers.map($rootScope.parseFloatOpts);
      return extractedNumbers;
    };

    $rootScope.parseFloatOpts = function(str) {
      if (typeof str === "number") {
        return str;
      }

      var ar = str.split(/\.|,/);

      var value = "";
      for (var i in ar) {
        if (i > 0 && i == ar.length - 1) {
          value += ".";
        }
        value += ar[i];
      }
      return Number(value);
    };

    // Broadcasts a message to pgSearch directive to toggle search overlay
    $scope.showSearchOverlay = function() {
      $scope.$broadcast("toggleSearchOverlay", {
        show: false
      });
    };
  }
]);

angular
  .module("AccountingBoxApp").config(['$qProvider', function ($qProvider) {
  $qProvider.errorOnUnhandledRejections(false);
}]);



function configDecorators($provide) {

  $provide.decorator("$exceptionHandler", exceptionHandler);

  exceptionHandler.$inject = ['$delegate', '$injector'];
  function exceptionHandler($delegate, $injector) {
    return function (exception, cause) {

      if ((exception.toString().toLowerCase()).includes("Possibly unhandled rejection".toLowerCase())) {
        console.log(exception); /* optional to log the "Possibly unhandled rejection" */
        return;
      }
      $delegate(exception, cause);
    };
  }
};
configDecorators.$inject = ["$provide"];

angular
  .module("AccountingBoxApp")
  .config(configDecorators);


angular
  .module("AccountingBoxApp").run(["$locale", function ($locale) {
  $locale.NUMBER_FORMATS.GROUP_SEP = ".";
  $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";
  console.log('locale',$locale);
}]);

angular
  .module("AccountingBoxApp")
  .config(function($stateProvider, $ocLazyLoadProvider) {
    $stateProvider.state("app", {
      abstract: true,
      templateUrl: "app/components/core/app.html",
      resolve: {
        loadDependencies: [
          "$ocLazyLoad",
          function($ocLazyLoad) {
            return $ocLazyLoad.load(
              [
                "dataTables",
                "panzoom",
                "medium-zoom",
                "daterangepicker",
                "nvd3",
                "rickshaw"
              ],
              {
                insertBefore: "#lazyload_placeholder"
              }
            );
          }
        ],
        currentUser: function(Auth) {
          return new Promise(function(resolve, reject) {
            return Auth.refreshCurrentUser(function(user) {
              console.log('pusher currentUser',user)
              resolve(user);
            });
          });
        }
      },
      controller: function(Auth, $rootScope, $stateParams, $scope){

        socket.connect();
        $rootScope.users = {}

        socket.on('user company update', data => {
          $rootScope.users[data.socketId] = data;
          // console.log('user company update', data);
          // console.log('users', $rootScope.users);
          $scope.$apply()
        })

        if($rootScope.isBookkeeper()){
          socket.on('get active users response', data => {
            $rootScope.users = data;
            // console.log('users', $rootScope.users);
            $scope.$apply()
          })
          socket.emit('get active users request');
        }
      }
    });
  });


angular
  .module("AccountingBoxApp")
  .config(function($stateProvider) {

    $stateProvider
      .state('react', {
        url: '/r/',
        abstract: true,
        template: '<react-app/>'
      })
      .state('react.page', {
        url: '*path',
      })

      // .state('app.company.react', {
      //   url: '/r',
      //   abstract: true,
      //   template: '<div class="react-new"><react-app/></div>',
      //   })
      //   .state('app.company.react.page', {
      //       url: '*path',
      //   })

      .state('app.company.reactApp', {
        url: '/react-app',
        abstract: true,
        template: '<div class="react-new"><react-app/></div>',
      })
      .state('app.company.reactApp.page', {
        url: '*path',
      })

  });


angular
  .module("AccountingBoxApp")
  .config(function($stateProvider, $ocLazyLoadProvider) {
    $stateProvider.state("app.company", {
      abstract: true,
      url: "/:companySlug",
      templateUrl: "app/components/core/company.html",
      resolve: {
        currentCompany: function($stateParams, Company, $rootScope, $window) {
          $rootScope.companySlug = $stateParams.companySlug
          return new Promise(function(resolve, reject) {
            // console.log(
            //   "stateParams current company:",
            //   $stateParams.companySlug
            // );
            return Company.findById(
              { id: $stateParams.companySlug, filter: { include: ["users", "bookkeeper", "taxAdvisor"] } },
              function(company) {
                company.email = company.users[0].email;
                company.user = company.users[0];
                company.mailto = encodeURI(`mailto:${company.users[0].email}?body=Beste ${company.users[0].firstName},\n\n\n`);
                // console.log("current company,", company);
                $rootScope.currentCompany = company;
                $window.document.title = company.name + ' - AdministratieBox';

                resolve(company);
                if (!$rootScope.currentCompany.phone) {
                  setTimeout(function() {
                    $rootScope.editSettings($rootScope.currentCompany, true);
                  }, 200);
                }
              },
              function() {
                console.log("Couldn't find company");
                $rootScope.logout();
              }
            );
          });
        }
      },
      controller: function($stateParams, $rootScope, Auth, $scope) {
        socket.emit('current company changed', { currentCompanySlug: $rootScope.companySlug, ... Auth.getCurrentUser() })
        $scope.$on("$destroy", function() {
          $rootScope.companySlug = null;
          socket.emit('current company changed', { currentCompanySlug: null, ... Auth.getCurrentUser() })
        });
      }
    });
  });

angular
  .module("AccountingBoxApp")
  /*
          Use this directive together with ng-include to include a
          template file by replacing the placeholder element
      */

  .directive("includeReplace", function() {
    return {
      require: "ngInclude",
      restrict: "A",
      link: function(scope, el, attrs) {
        el.replaceWith(el.children());
      }
    };
  });
